import React from "react";
import Features from "../components/Features";

export default function MultiCurrencySavings() {
  return (
    <div className="multi-currency-page">
      {/* HERO SECTION */}
      <section className="multi-hero">
        <div className="multi-left">
          <h1>Multi-Currency Savings</h1>
          <p>
            Take control of your wealth across borders with flexible savings in multiple major currencies — 
            all managed from a single secure Swiss account.
          </p>
          <p>
            Whether you’re an international entrepreneur, expatriate, or global investor, 
            our multi-currency savings solution helps you diversify, grow, and protect your assets 
            in the world’s strongest currencies.
          </p>
        </div>
        <div className="multi-right">
          <img src="/service3.png" alt="Multi-Currency Savings" />
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="multi-details">
        <h2>Preserve and Grow Wealth in 25+ Global Currencies</h2>
        <p>
          Our multi-currency savings accounts combine Swiss reliability with 
          global accessibility — allowing you to hold, convert, and manage balances 
          in up to 25 international currencies. Perfect for high-net-worth individuals, 
          international business owners, and offshore investors seeking flexibility and control.
        </p>

        <ul>
          <li>✅ Hold funds in CHF, USD, EUR, GBP, JPY, and more</li>
          <li>✅ Instantly convert between currencies at competitive rates</li>
          <li>✅ Access your savings anytime with secure digital banking</li>
          <li>✅ Earn attractive interest while diversifying globally</li>
          <li>✅ Manage your portfolio with advanced financial insights</li>
        </ul>
      </section>

      {/* FEATURES SECTION */}
      <Features />
    </div>
  );
}

/* ---------------------- CSS BELOW ---------------------- */

const styles = `
.multi-currency-page {
  background: #f9fafc;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  padding-bottom: 60px;
}

.multi-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 10%;
  gap: 40px;
  background: white;
}

.multi-left {
  flex: 1;
}

.multi-left h1 {
  font-size: 2.5rem;
  color: #b01724;
  margin-bottom: 20px;
}

.multi-left p {
  margin-bottom: 15px;
  font-size: 1.05rem;
  color: #333;
}

.multi-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.multi-right img {
  width: 90%;
  max-width: 480px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.12);
}

.multi-details {
  padding: 60px 10%;
  max-width: 1000px;
  margin: 0 auto;
}

.multi-details h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #111;
}

.multi-details p {
  margin-bottom: 20px;
  color: #444;
}

.multi-details ul {
  list-style: none;
  padding-left: 0;
}

.multi-details li {
  margin-bottom: 10px;
  font-size: 1rem;
}

@media (max-width: 900px) {
  .multi-hero {
    flex-direction: column;
  }
  .multi-right img {
    width: 100%;
  }
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
